import { AppRoutes } from "./routes/AppRoutes";
import { AppLayout } from "./shared/components/layout/AppLayout";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./reactQueryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-center"
        toastOptions={{
          success: {
            duration: 4000,
          },
          error: {
            duration: 4000,
          },
        }}
      />
      <AppLayout>
        <AppRoutes />
      </AppLayout>
    </QueryClientProvider>
  );
}
export default App;
